import React, { useState } from 'react';
import { md, isBlankBlock } from '../utils/markdown';

const RestaurantSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [results, setResults] = useState('');

  const RESTAURANT_API_BASE_URL = 'https://cg5dfxejik.execute-api.ap-northeast-2.amazonaws.com/restaurant';

  const getCurrentPosition = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('위치 정보가 지원되지 않습니다.'));
      }

      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      });
    });
  };

  const handleCategoryClick = async (category) => {
    setSelectedCategory(category);
    setResults('위치 정보를 확인하는 중입니다...');

    try {
      const position = await getCurrentPosition();
      const { latitude, longitude } = position.coords;

      setResults('맛집 추천 데이터를 가져오는 중입니다...');

      const response = await fetch(`${RESTAURANT_API_BASE_URL}/restaurant`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          category,
          latitude,
          longitude
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const formattedRecommendations = data.recommendations
          .split('\n\n')
          .filter(p => !isBlankBlock(p))
          .map(p => `<div class="analysis-paragraph">${md(p.trim())}</div>`)
          .join('');

        setResults(`
          <h3>🍽️ 현재 위치 기준 추천 맛집</h3>
          <div class="analysis-content">
            ${formattedRecommendations}
          </div>
        `);
      } else {
        const errorData = await response.json();
        setResults(`에러 발생: ${errorData.message}`);
      }
    } catch (error) {
      console.error('맛집 추천 오류:', error);
      if (error.message.includes('위치 정보')) {
        setResults('위치 정보 접근이 거부되었습니다. 위치 정보 접근을 허용해주세요.');
      } else {
        setResults(`서버와 통신 중 오류가 발생했습니다: ${error.message}`);
      }
    }
  };

  const categories = ['한식', '양식', '중식', '일식'];

  return (
    <section className="service-section">
      <h2>맛집 추천 AI 서비스</h2>
      <p className="info-text">(위치 기반 추천)</p>
      <div className="button-container">
        {categories.map(category => (
          <button
            key={category}
            className={`category-btn ${selectedCategory === category ? 'selected' : ''}`}
            onClick={() => handleCategoryClick(category)}
          >
            {category}
          </button>
        ))}
      </div>
      {results && <div className="results" dangerouslySetInnerHTML={{ __html: results }}></div>}
    </section>
  );
};

export default RestaurantSection;